import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {IScheduleDateAddFormRequest} from "../models/Schedule";
import ScheduleDateAdd from "../components/ScheduleDateAdd";
import {addScheduleDateForm, closeScheduleDateForm} from "../store/actions/scheduleDateForm";
import {IDictionary} from "../models/Dictionary";
import Loader from "../components/UI/Loader";
import Error from "../components/UI/Error";
import {getDictionaryCouriers} from "../store/actions/dictionaryCouriers";
import {getDictionaryPoints} from "../store/actions/dictionaryPoints";
import Empty from "../components/UI/Empty";


type ScheduleDateAddType = {
    addScheduleDateForm: (id: number, date: string, form: IScheduleDateAddFormRequest[]) => void
    getDictionaryPoints: (cityId: number) => void
    getDictionaryCouriers: (cityId: number) => void
    closeScheduleDateForm: () => void
    changeLoading: boolean
    changeError: string
    id: number
    date: string
    cityId: number
    points: IDictionary[]
    pointsLoading: boolean
    pointsError: string
    couriers: IDictionary[]
    couriersLoading: boolean
    couriersError: string
}


class ScheduleDateAddContainer extends Component<ScheduleDateAddType> {

    componentDidMount() {
        const {getDictionaryPoints, getDictionaryCouriers, cityId} = this.props;
        getDictionaryPoints(cityId);
        getDictionaryCouriers(cityId);
    }

    render() {
        const {
            changeLoading, changeError, addScheduleDateForm, id, date, points, couriers,
            pointsLoading, pointsError, couriersLoading, couriersError, getDictionaryPoints, cityId, getDictionaryCouriers,
            closeScheduleDateForm
        } = this.props;

        if (pointsLoading || couriersLoading) {
            return <Loader/>
        }

        if (pointsError) {
            return <Error error={pointsError} refresh={() => getDictionaryPoints(cityId)}/>
        }

        if (couriersError) {
            return <Error error={couriersError} refresh={() => getDictionaryCouriers(cityId)}/>
        }

        if (!!points.length && !!couriers.length) {
            return (
                <ScheduleDateAdd
                    addScheduleDateForm={(form) => addScheduleDateForm(id, date, form)}
                    changeLoading={changeLoading}
                    changeError={changeError}
                    points={points}
                    couriers={couriers}
                    cancelHandler={closeScheduleDateForm}
                />
            )
        }
        return (
            <Empty>
                {!points.length &&
                <>
                    <h3>Список отправных точек пуст</h3>
                    <p className={'mb-0'}>Добавьте отправные точки</p>
                </>}
                {!couriers.length &&
                <>
                    <h3>Список курьеров пуст</h3>
                    <p className={'mb-0'}>Добавьте курьеров</p>
                </>}
            </Empty>
        )
    }
}

const mapStateToProps = ({scheduleDateForm, dictionaryPoints, dictionaryCouriers}: AppState) => {
    return {
        changeLoading: scheduleDateForm.changeLoading,
        changeError: scheduleDateForm.changeError,
        points: dictionaryPoints.data,
        pointsLoading: dictionaryPoints.loading,
        pointsError: dictionaryPoints.error,
        couriers: dictionaryCouriers.data,
        couriersLoading: dictionaryCouriers.loading,
        couriersError: dictionaryCouriers.error
    }
};

const mapDispatchToProps = {
    addScheduleDateForm,
    getDictionaryCouriers,
    getDictionaryPoints,
    closeScheduleDateForm
};


export default connect(mapStateToProps, mapDispatchToProps)(ScheduleDateAddContainer);
